<template>
  <v-card tile flat color="Neutral">
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          class="pa-0"
          style="background-color: var(--v-Neutral-base)"
        >
          <v-data-iterator
            :items="statisticsList"
            :items-per-page="-1"
            :footer-props="{ 'items-per-page-text': $t('lblRowsPerPage') }"
            :no-results-text="$t('emptySearchRecords')"
            :loading-text="$t('LoaderText')"
            :no-data-text="$t('noData')"
            :loading="loaderLoading"
          >
            <template #no-data>
              <strong>{{ $t("noData") }}</strong>
            </template>
            <template #default="{ items }">
              <v-row>
                <v-col
                  v-for="(item, index) in items"
                  :key="index"
                  cols="12"
                  sm="6"
                  md="6"
                  class="pa-2"
                >
                  <statistics-analysis-card
                    :item="item"
                    @openDialog="openDialog"
                  />
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>

          <!-- Render dialogs dynamically -->
          <component
            v-for="(isOpen, key) in dialogComponents"
            :is="key"
            :key="key"
            v-model="dialogComponents[key]"
            :hasCalledFromStatistics="true"
          />
        </v-col>
      </v-row>

      <Loader :loading="loaderLoading" :message="loaderText" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import FilterDialog from "@/components/statistics/FilterDialog.vue";
import TimeAllocationFilter from "@/components/statistics/TimeAllocationFilter.vue";
import FeedbackMeetingFilter from "./FeedbackMeetingFilter.vue";
import Loader from "@/components/Loader.vue";
import StatisticsAnalysisCard from "./StatisticsAnalysisCard.vue";

export default {
  name: "UserInfo",
  components: {
    StatisticsAnalysisCard,
    Loader,
    FilterDialog,
    TimeAllocationFilter,
    FeedbackMeetingFilter,
  },
  data() {
    return {
      loaderLoading: false,
      dialogComponents: {
        FilterDialog: false,
        TimeAllocationFilter: false,
        FeedbackMeetingFilter: false,
      },
    };
  },
  created() {
    sessionStorage.setItem("TopicFeedbackFilterInputs", null);
  },
  async mounted() {
    this.loaderLoading = true;
    try {
      await this.getCachedUserList();
    } catch (error) {
      console.error(error);
    } finally {
      this.loaderLoading = false;
    }
  },
  methods: {
    ...mapActions({
      getCachedUserList: "people/getCachedUserList",
    }),
    openDialog({ isDialogOpen, item }) {
      const dialogMap = {
        attendance_analysis: "FilterDialog",
        topic_feedbacks: "FeedbackMeetingFilter",
        time_allocation: "TimeAllocationFilter",
      };

      if (dialogMap[item.id]) {
        this.dialogComponents[dialogMap[item.id]] = isDialogOpen;
      }
    },
  },
  computed: {
    loaderText() {
      return this.$t("LoaderText");
    },
    statisticsList() {
      return [
        {
          id: "attendance_analysis",
          title: this.$t("statistics.hAttendanceAnalysis"),
        },
        { id: "time_allocation", title: this.$t("statistics.hTimeAllocation") },
        {
          id: "topic_feedbacks",
          title: this.$t("statistics.lblTopicFeedback"),
        },
      ];
    },
  },
};
</script>

<style scoped>
::v-deep .e-date-wrapper {
  border: 1px solid gray !important;
  border-radius: 4px !important;
  padding: 0 5px !important;
  height: 40px;
  font-size: 15px !important;
}

::v-deep .e-date-wrapper .e-input-group-icon {
  min-height: 18px !important;
  min-width: 18px !important;
}

.selectField /deep/ .v-input__slot {
  min-height: 40px !important;
}

.selectField /deep/ .v-label {
  line-height: 16px !important;
}

.selectField {
  font-family: "Noto Sans JP" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
}
</style>
